import React, { useState } from "react";
import { Container, Row, Col, Alert, Button } from "react-bootstrap";
import WithProducts from "../../HOC/HOCProducts";
import ProductCard from "../Product/ProductCard";
import { GrFormPrevious } from "react-icons/gr";
import { GrFormNext } from "react-icons/gr";

const Jewellery = ({ jewellery, handleDelete, handleAddToCart, handlePagination, keywords, page, pages, total }) => {

  const handleFirstPage = (e) => {
    e.preventDefault();
    const updated = { ...keywords, page: 1, limit: keywords.limit };
    handlePagination(updated);
  }
  const handleLastPage = (e) => {
    e.preventDefault();
    handlePagination({ ...keywords, page: pages })
  }
  const handleNext = (e) => {
    e.preventDefault();
    const updated = { ...keywords, page: keywords.page + 1, limit: keywords.limit };
    handlePagination(updated);

  };

  const handlePrev = (e) => {
    e.preventDefault();
    if (keywords.page > 1) {
      handlePagination({ ...keywords, page: keywords.page - 1, limit: keywords.limit });
    }
  };

  if (!Array.isArray(jewellery) || jewellery.length === 0) {
    return (
      <Alert variant="info" className="text-center">
        No products available. <br />
        <span className="fw-bold">Check back later or contact support.</span>
      </Alert>
    );
  }

  return (
    <Container>
      <Row>
        <Col lg={12}>
          <h1 className="text-center hover-underline">Jewellery</h1>
        </Col>
      </Row>

      <Row className="row-xs-no-padding">
        {Array.isArray(jewellery) && jewellery.map((product) => (
          <Col key={product._id} lg={3} md={6} sm={6} xs={6} className="mb-3">
            <ProductCard
              product={product}
              handleDelete={handleDelete}
              handleAddToCart={handleAddToCart}
            />
          </Col>
        ))}
      </Row>

      <Row className="my-3 text-center">
        <Col lg={{ span: 6, offset: 3 }}>
          <div className="d-flex w-100 justify-space-between justify-content-center align-items-center">
            <Button variant="link" onClick={handleFirstPage} > <GrFormPrevious />Page 1</Button>
            <Button variant="outline-primary" onClick={handlePrev} disabled={page === 1}> <GrFormPrevious className="me-2" />Previous</Button>
            <div className="page-info">
              Page {page} of {pages}
            </div>
            {keywords.page < pages && <>
              <Button variant="outline-primary" onClick={handleNext} > Next<GrFormNext className="ms-2" /></Button>
              <Button variant="link" onClick={handleLastPage}>Page {pages} <GrFormNext /></Button></>
            }
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default WithProducts(Jewellery);